<style lang="scss" scoped>
.scroll-view {
  position: relative;
  // transform: translate3d(0, 0, 0);

  box-sizing: border-box;

  flex: auto;
  -webkit-overflow-scrolling: touch;
  .scroll-bottom {
    height: 1rem;

    font-size: 0.24rem;
    line-height: 1rem;
    text-align: center;
    color: #999;
    img {
      display: inline-block;

      vertical-align: middle;
    }
    span {
      display: inline-block;

      margin-left: 0.1rem;

      vertical-align: middle;
    }
  }
  .finish {
    font-size: 0.24rem;
    color: #8c8c8c;
  }
}
</style>

<template>
  <div class="scroll-view" :style="evaStyle" @scroll.passive="hanlderScroll">
    <slot></slot>
    <div v-if="reachBottomLoading || finish" class="scroll-bottom">
      <p v-show="reachBottomLoading">
        <img src="@/images/loading/loading.gif" width="24" /><span>加载中</span>
      </p>
      <div v-show="finish">
        <span class="finish">- 已经到底了 -</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: String,
      default: '',
      required: false
    },
    reachBottomLoading: {
      type: Boolean,
      default: false
    },
    finish: {
      type: Boolean,
      default: false
    },
    isScroll: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    evaStyle() {
      const _style = {}
      if (this.background) _style.backgroundColor = this.background
      _style.overflowY = this.isScroll ? 'auto' : 'hidden'
      return _style
    }
  },
  methods: {
    hanlderScroll(e) {
      this.$emit('onScroll', e)
      if (this.reachBottomLoading || this.finish) return false
      const ctn = e.currentTarget
      if (ctn.scrollTop + ctn.offsetHeight > ctn.scrollHeight - 30) {
        this.$emit('loadData')
      }
    }
  }
}
</script>
